import styled from 'styled-components';

const Header = styled.h1`
  color: #414141;
  margin-bottom: 35px;
  margin-top: -5px;

  @media (max-width: 421px){
    font-size: 26px;
  }
`;

export default Header;
